<template>
    <div>

<!--<section class="section has-background-primary ls-hero-image"><div class="container"><div class="columns"><div class="column is-3 has-text-white"><h4 class="title is-3 has-text-white">Drag & Drop Editor</h4><div class="content"><p>Pellentesque dictum purus leo, et placerat turpis porta gravida. In cursus diam id ipsum vulputate, ut venenatis eros porta. Aenean fringilla a nisi ac viverra.</p></div><a class="button has-text-weight-bold ls-button is-success">Get Started</a><br></div><div class="column is-6"><img src="https://minutemerge.s3.us-east-2.amazonaws.com/Gif1.gif" alt=""></div></div></div></section>
-->

<section class="section" style="background: linear-gradient(90deg,#377fea 20%,#653dea) #377fea;">

<h4 class="title has-text-white ">One-minute Setup</h4>
<p class="content has-text-grey is-size-5">Build your automation easily.</p>

<div class="container"><div class="columns"><div class="column is-8-desktop is-offset-2-desktop"><div class="ls-section-content has-text-centered"></div></div></div><div class="columns"><div class="column is-one-third"><article class="custcard card ls-feature-card"><div class="card-content"><figure class="image is-159x159"><img src="../img/fffdesign.svg" title="LandSpeed UI" width="145" height="159"></figure><br><div class="media-content has-text-centered"><h3 class="title is-4 has-text-weight-bold"><a href="/" class="has-text-white" title="">1. Create</a></h3><p class="is-size-6 custext">Build your own template.</p></div></div></article></div><div class="column is-one-third"><article class="custcard card ls-feature-card"><div class="card-content"><figure class="image is-159x159"><img src="../img/api999.svg" title="LandSpeed UI" width="145" height="159"></figure><br><div class="media-content has-text-centered"><h3 class="title is-4 has-text-weight-bold"><a href="/" class="has-text-white" title="">2. Connect</a></h3><p class="is-size-6 custext">Connect to your
favorite apps.</p></div></div></article></div><div class="column is-one-third"><article class="custcard card ls-feature-card"><div class="card-content"><figure class="image is-159x159"><img src="../img/fffdesign6.svg" title="LandSpeed Fast Performance" width="145" height="159"></figure><br><div class="media-content has-text-centered"><h3 class="title is-4 has-text-weight-bold"><a href="/" class="has-text-white" title="">3. Automate</a></h3><p class="is-size-6 custext">Generate images and PDFs
dynamically.</p></div></div></article></div></div></div>

<br>
</section>


 <!--    <section class="section ls-hero-icons" style="background: linear-gradient(90deg,#377fea 20%,#653dea) #377fea;">
        <div class="container">
                <div class="column is-8-desktop is-offset-2-desktop">
                <div class="ls-section-content has-text-centered" style=" margin-bottom: 0;">
                    <h3 class="title has-text-white">Setup in a Minute</h3>
                            <br>
                    <p class="content has-text-grey is-size-5">Capitalize on low hanging fruit to identify a ballpark value added activity to beta test. Override the digital divide with additional clickthroughs.</p>
                </div>
            </div>

        <div class="column">
          <figure class="image is-256x256">
  <img src="../img/MinuteMergePathSVGnoTEXTbluebackgrd5.svg">
</figure>          
</div>
        

        <br>
<ul class="steps is-large">
  <li class="step-item">
    <div class="step-marker">1</div>
    <div class="step-details is-primary is-completed">
      <p class="step-title">Create</p>
      <p>Easy drag & drop <br>editor</p>
    </div>
  </li>
  <li class="step-item">
    <div @click="alert()" class="step-marker">2</div>
        <div class="step-details is-primary is-completed">
      <p class="step-title">Connect</p>
      <p>Connect to your <br>favorite apps</p>
    </div>
  </li>
  <li class="step-item">
    <div class="step-marker">3</div>
        <div class="step-details is-primary is-completed">
      <p class="step-title">Automate</p>
      <p>Generate documents <br> dynamically</p>
    </div>
  </li>
</ul>

<br>

        </div>
      </section> -->


    </div>
</template>

<script>

    export default {
        
    }
</script>

<style lang="css" scoped>

.custext {
    color: #d0d0d0 !important;
}

.custcard {
    background-color: #ffffff1a!important;
}

</style>